import { ReactElement, ReactNode, useCallback } from 'react';

import {
  hideModal as hideModalAction,
  showModal as showModalAction,
} from 'modules/main/store/ducks/modal.actions';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';

export function useModalContainerFunctions() {
  const dispatch = useMainDispatch();

  const showModal: typeof showModalAction = useCallback(
    (...args) => dispatch(showModalAction(...args)),
    [dispatch],
  );

  const hideModal: typeof hideModalAction = useCallback(
    (...args) => dispatch(hideModalAction(...args)),
    [dispatch],
  );

  return { showModal, hideModal };
}

type Props = {
  render: (
    showModal: typeof showModalAction,
    hideModal: typeof hideModalAction,
  ) => ReactNode;
};

export function ShowModalContainer({ render }: Props): ReactElement {
  const { showModal, hideModal } = useModalContainerFunctions();

  return <>{render(showModal, hideModal)}</>;
}
